// Registers the service worker for PWA installability + offline app-shell
// loading. Deliberately does nothing beyond registration -- no update prompts,
// no background sync, no offline queueing. If registration fails (unsupported
// browser, dev environment quirk, etc.) the app continues working online-only.
export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((err) => {
      console.error('Service worker registration failed', err);
    });
  });
}
